export default __webpack_public_path__ + "static/media/wienner-cone.b0390e7c.jpg";